<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'app',
	components: {
      
    }
}
</script>

<style scoped>
#app {
  font-family:'SF Pro Text',arial,verdana,helvetica,'PingFang SC','HanHei SC','STHeitiSC-Light','Source Han Sans','Microsoft Yahei',sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  text-align: left;
  max-width:37.5rem;
	margin:0 auto;
  background-color:white;
}
</style>



// WEBPACK FOOTER //
// App.vue?ece1087e